import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'al0003',
    ecrans: ['00-2'],
    params: ['id', '?dalcleint', '?tdlcleint', '?lemcleint', '?dalseqmodcou', '?eclcleint']
});
